var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncommonS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23825 1L5.23825 1.76172H4.47646V2.52351H5.23825L5.23825 1.76179H6.79668V1H5.23825ZM6.80055 1.76172V2.52351H7.56234V1.76172H6.80055ZM6.80055 4.46842V5.23022H7.56234V4.46842H6.80055ZM5.23828 6.78892V7.5387H4.47646V6.77691H5.23825V5.2305H6.79668V6.78892H5.23828ZM6.79668 6.77311V7.53491H7.5585V6.77311H6.79668ZM6.79668 10.234V9.47222H7.55847V10.234H6.79668ZM7.56234 7.53878V9.4723H8.32414V8.30042H9.51521V7.5387H10.2732V6.77691H9.51134V7.53863H7.64358V7.53878H7.56234ZM3.71466 9.4761V8.31236H2.52746V7.55056H4.47643V7.74367H4.47648V9.4761H3.71466ZM4.47646 9.47656V10.2384H5.23825V9.47656H4.47646ZM4.47646 5.23022V4.46842H5.23825V5.23022H4.47646ZM1.76566 4.46842V5.23022H2.52746V4.46842H1.76566ZM1.76179 7.53491V6.78863H1V5.23022H1.76181V6.77311H2.52361V7.53491H1.76179ZM9.51521 5.23022V4.46842H10.277V5.23022H9.51521ZM10.277 5.23022H11.0388V6.78863H10.277V5.23022ZM5.24212 11.0001V10.2383H6.80053V11.0001H5.24212ZM7.57009 4.4647H9.5036V3.70291H8.33188V2.51549H7.57009V3.70291V4.38712V4.4647ZM4.47646 4.46083V2.52731H3.71466V3.69919H2.52361V4.46098H4.39527V4.46083H4.47646Z",
    fill: "#25EF52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncommonS);
export default __webpack_public_path__ + "static/media/uncommon-s.f24e5bf9b08858e1f32d66458a5c20ae.svg";
export { ForwardRef as ReactComponent };